<iframe
  *ngIf="renderIframe$ | async"
  [attr.src]="iframeSrc$ | async | finSafe: 'resource'"
  class="is-vishidden"
  title=""
  aria-hidden="true"
></iframe>
